<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$( document ).ready(function() {
     $(".customf_button").click(function(){
        var is_validate = true;
        var current_template = $('#current_template').val();
        var custom_text_limit = $('#custom_text_limit').text();
        if(custom_text_limit != ''){
          custom_text_limit = custom_text_limit;
        }else{
          custom_text_limit = 40;
        }
    
        if(current_template == 'custom-text-on-sigle-side'){
          var gift_input = $('.custom_inputs #input-1').val();
          var result = singleInputvalue(gift_input, custom_text_limit);
          if(result == 'false'){
            is_validate = false;
          }
        }

        if(current_template == 'custom-text-on-both-side'){
          var gift_input = $('.custom_inputs #input-1').val();
          var gift_input2 = $('.custom_inputs #input-2').val();
          var result = towInputvalue(gift_input, gift_input2, custom_text_limit);
          if(result == 'false'){
            is_validate = false;
          }
        }

        if(current_template == 'custom-image-and-text'){
          var gift_input = $('.custom_inputs #input-1').val();
          var gift_image = $('.custom_inputs #file-1').val();
          var result = InputAndImage(gift_input, gift_image, custom_text_limit);
          if(result == 'false'){
            is_validate = false;
          }
        }
    

       if(current_template == 'custom-two-text-and-image'){
          var gift_input = $('.custom_inputs #input-1').val();
          var gift_input2 = $('.custom_inputs #input-2').val();
          var gift_image = $('.custom_inputs #file-1').val();

         var result = towInputvalue(gift_input, gift_input2, custom_text_limit);
          if(result == 'false'){
            is_validate = false;
          }
          var result = singleImage(gift_image);
          if(result == 'false'){
            is_validate = false;
          }
         
        }

        if(current_template == 'custom-image'){
          var gift_image = $('.custom_inputs #file-1').val();
          var result = singleImage(gift_image);
          if(result == 'false'){
            is_validate = false;
          }
        }
    
      if(is_validate){
        $(".main_atc").trigger("click");
        $('.custom_inputs #input-1').val('');
        $('.custom_inputs #input-2').val('');
        $('.custom_inputs #file-1').val('');
      }
  });  
  
function singleInputvalue(gift_input, custom_text_limit) {
    var is_validate = 'true';
    
      $('.custom_inputs .input_text1').find('.set.text-danger').remove();
      if(gift_input == ''){
        is_validate = 'false';
        $('.custom_inputs .input_text1').append('<div class="set text-danger">Enter your text here.</div>');
      }else if (gift_input.length > custom_text_limit) {
        is_validate = 'false';
        $('.custom_inputs .input_text1').append('<div class="set text-danger">Maximum character limit is '+custom_text_limit+'.</div>');
      }
  
      return is_validate;
}

function towInputvalue(gift_input, gift_input2, custom_text_limit) {
  var is_validate = 'true';
  
  
    $('.custom_inputs .input_text1').find('.set.text-danger').remove();
    if(gift_input == ''){
      is_validate = 'false';
      $('.custom_inputs .input_text1').append('<div class="set text-danger">Enter your text here.</div>');
    }else if (gift_input.length > custom_text_limit) {
      is_validate = 'false';
      $('.custom_inputs .input_text1').append('<div class="set text-danger">Maximum character limit is '+custom_text_limit+'.</div>');
    }

    $('.custom_inputs .input_text2').find('.set.text-danger').remove();
    if(gift_input2 == ''){
      is_validate = 'false';
      $('.custom_inputs .input_text2').append('<div class="set text-danger">Enter your text here.</div>');
    }else if (gift_input2.length > custom_text_limit) {
      is_validate = 'false';
      $('.custom_inputs .input_text2').append('<div class="set text-danger">Maximum character limit is '+custom_text_limit+'.</div>');
    }
  
    return is_validate;
}

function InputAndImage(gift_input, gift_image, custom_text_limit) {
  var is_validate = 'true';
  
  
    $('.custom_inputs .input_text1').find('.set.text-danger').remove();
    if(gift_input == ''){
      is_validate = 'false';
      $('.custom_inputs .input_text1').append('<div class="set text-danger">Enter your text here.</div>');
    }else if (gift_input.length > custom_text_limit) {
      is_validate = 'false';
      $('.custom_inputs .input_text1').append('<div class="set text-danger">Maximum character limit is '+custom_text_limit+'.</div>');
    }

    $('.custom_inputs .input_file').find('.image_f.text-danger').remove();
    if(gift_image == ''){
     is_validate = 'false';
     $('.custom_inputs .input_file').append('<div class="image_f text-danger">Select your image here.</div>');
    }
  
    return is_validate;
}

function singleImage(gift_image) {
  var is_validate = 'true';

    $('.custom_inputs .input_file').find('.image_f.text-danger').remove();
    if(gift_image == ''){
     is_validate = 'false';
     $('.custom_inputs .input_file').append('<div class="image_f text-danger">Select your image here.</div>');
    }
  
    return is_validate;
}
  
  
});